import { Link } from "gatsby";
import React from "react";
import { getFromConfig } from "../../utils/localeURL";
// import Logo from "../../images/SalmonSoftware_logo.png";
import Logo from "../../svg/SalmonSoftware_logo.svg";

import HeaderNav, { HeaderData } from "./HeaderNav";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { IHeaderData } from "Root/src/queries/layout-queries";

const rootClass = `header`;
const localizedHomepageUrl = `/${getFromConfig(
  process.env.GATSBY_LOCALE ?? `en`,
  `urlPrefix`,
  `SalmonSoftwareGatsby`
)}`;

interface HeaderPropsType {
  customHeaderClass?: string;
  style?: string;
  landingPageNav?: HeaderData;
  headerData: IHeaderData
}

const Header: React.FunctionComponent<HeaderPropsType> = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);
  const headerData: HeaderData | any = props.headerData?.menu ? props.headerData?.menu[0]?.menuItemsList : null

  useScrollPosition(({ currPos }) => {
    if (currPos.y !== 0) {
      setIsScrolled(true)
    } else {
      setIsScrolled(false)
    }
  }, [isScrolled])

  return (
    <div
      className={`${props.customHeaderClass ?? ``}`}
    >
      <header className={`${isOpen ? `is-opened ` : ``}${isScrolled ? "is-scrolled " : ""}`}>
        <div
          className='Header'
        >
          <div className={`HeaderLogo`}>
            <Link to={localizedHomepageUrl}>
              <img src={Logo} alt="logo" className="Logo" width="auto" height="60" />
            </Link>
          </div>
          <div
            className={`HeaderBurger`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <HeaderNav headerData={headerData} />
        </div>
      </header>
      <div
        className={`Header-spacer${isScrolled ? " is-scrolled" : ""}`}
      ></div>
    </div>
  );
};

export default Header;
